import makeStyles from "@mui/styles/makeStyles";
import DataGridView from "components/grid/DataGridView";
import {
  tooltipFormatter,
  valueFormatter
} from "components/grid/dateFormatter";
import { RenderableColumnDefinition } from "components/grid/gridTypings";
import { IColumnProps } from "devextreme-react/data-grid";
import { InputDataTables, ResultDataTables } from "features/use-case";

import { Tooltip } from "@mui/material";

import _ from "lodash";

const useStyles = makeStyles({
  flex: { flex: "1 1 auto", overflow: "auto" },
  tooltip: {
    backgroundColor: "#fff",
    border: "solid 1px rgb(0, 0, 0, 0.9)",
    borderRadius: 0,
    color: "rgb(0, 0, 0, 0.9)"
  }
});

type TableSetGridProps = {
  useCaseKey: string;
  useCaseVersion?: string | null;
  dataKey?: string;
  calculationId: string;
  name: string;
  columnDefs?: (
    schemaName: string
  ) => RenderableColumnDefinition<IColumnProps, {}>[];
  loadData: any;
};

const TableSetGrid = ({
  useCaseKey,
  useCaseVersion = null,
  dataKey,
  calculationId,
  name,
  columnDefs,
  loadData
}: TableSetGridProps) => {
  const { flex, tooltip } = useStyles({});

  const dataSetViewModelToObjectRows = (
    table: InputDataTables | ResultDataTables | undefined
  ) => {
    if (table) {
      const columnNames = columnDefs?.(name).map(
        ({ colDef: { dataField } }) => dataField
      );
      const rowObjects = _(table.rows)
        .map(row => _.zipObjectDeep(columnNames, row!))
        .value();
      return rowObjects;
    }
  };
  const load = async (loadOptions: any) => {
    const skip = loadOptions.skip;
    const take = loadOptions.take;
    const table = dataKey
      ? await loadData(useCaseKey, useCaseVersion, dataKey, name, skip, take)
      : await loadData(
          useCaseKey,
          useCaseVersion,
          calculationId,
          name,
          skip,
          take
        );
    if (table) {
      const rows = dataSetViewModelToObjectRows(table);
      return {
        data: rows,
        totalCount: table.rowCount
      };
    }
  };

  const RenderableColumns = columnDefs?.(name).map(col => {
    if (col.typeName === "dateTime") {
      return _.omit(
        {
          ...col,
          render: (params: any) => {
            return (
              <Tooltip
                title={tooltipFormatter(params.value)}
                classes={{ tooltip }}
              >
                <div>{valueFormatter(params.value)}</div>
              </Tooltip>
            );
          }
        },
        "typeName"
      );
    } else return _.omit(col, "typeName");
  });

  return (
    <div className={flex}>
      <DataGridView
        load={load}
        columns={RenderableColumns}
        remoteOperations={true}
        allowSelection={false}
        showFilterRow={false}
      />
    </div>
  );
};

export default TableSetGrid;
